if (!customElements.get('chyde-youtube')) {
  customElements.define(
    'chyde-youtube',
    class ChydeYoutube extends HTMLElement {
      connectedCallback() {
        this.querySelector('.chyde-youtube__play')?.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey) return;
          event.preventDefault();
          this.load();
        });
      }

      load() {
        const iframe = document.createElement('iframe');
        const params = new URLSearchParams({ autoplay: '1', rel: '0', playsinline: '1' });
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.dataset.videoId)}?${params}`;
        iframe.title = this.dataset.title || 'YouTube video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(iframe);
        iframe.focus();
      }
    }
  );
}
